<div class="bloco">
  <h5 class="titulo">Dívidas vencidas</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  
  <div *ngIf="dados.pendencias_vencidas.registro.length > 0">
    <div class="row">
        <table class="table table-sm ">
            <thead>
              <tr>
                <th>Ocorrência</th>
                <th>Data</th>
                <th>Avalista</th>
                <th>Moeda</th>
                <th>Valor</th>
                <th>Nº contrato</th>
                <th>Informante</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dados.pendencias_vencidas.registro">
                <td>{{row.tipo_ocorrencia}}</td>
                <td>{{row.data_entrada}}</td>
                <td>{{row.avalista}}</td>
                <td>R$</td>
                <td>{{row.valor}}</td>
                <td>{{row.contrato}}</td>
                <td>{{row.informante}}</td>
                
              </tr>
            </tbody>
          </table>
    </div>
  </div>
</div>
  